import { createFileRoute } from "@tanstack/react-router";
import {
  type SetShopSearch,
  type ShopSearch,
  shopSearchSchema,
} from "#/lib/shop-search";
import { CollectionPage } from "#/pages/CollectionPage";

export const Route = createFileRoute("/living-books")({
  validateSearch: shopSearchSchema,
  head: () => ({ meta: [{ title: "Living Books" }] }),
  component: LivingBooksRoute,
});

function LivingBooksRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setShopSearch: SetShopSearch = (next) => {
    navigate({
      search: (prev: ShopSearch) => ({ ...prev, ...next }),
      replace: true,
      resetScroll: false,
    });
  };
  return (
    <CollectionPage
      kind="living-books"
      search={search}
      setShopSearch={setShopSearch}
    />
  );
}
